import script from "./BirthBeats.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthBeats.vue?vue&type=script&setup=true&lang=js"

import "./BirthBeats.vue?vue&type=style&index=0&id=31e21fc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31e21fc2"]])

export default __exports__